import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import ExpertsBanner from "../Components/Experts/ExpertsBanner";
import ExpertsContent from "../Components/Experts/ExpertsContent";
import Footer from "../Components/Footer";
import FacebookPixel from "../Components/FacebookPixel";

const Experts = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div className="overflow-hidden">
      <FacebookPixel />
      <Navbar />
      <ExpertsBanner />
      <ExpertsContent />
      <Footer />
    </div>
  );
};

export default Experts;
